var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"forecast"},_vm._l((_vm.forecast5Days),function(item,index){return _c('forecast-list-item',{key:index,attrs:{"date":item.date,"min-temperature":item.minTemperature,"max-temperature":item.maxTemperature,"temperature-measure":_vm.temperatureMeasure,"image":item.weatherIconCode}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }